import moment from 'moment';
import momentTimezone from 'moment-timezone';

export const now = () => moment();

export const US_DATE_FORMAT = 'MM/DD/YYYY';

const ISO_DATE_FORMAT = 'YYYY-MM-DD';
const US_COMPACT_DATE_FORMAT = 'M/D/YYYY';
const US_COMPACT_DATE_FORMAT_WITH_TIME_AND_TZ = 'M/D/YY, h:mmA z';
const US_HUMAN_DATE_TIME_WITH_TZ = 'MM/DD/YYYY [at] h:mma zz';
export const HUMAN_TIME_FORMAT = 'HH:mm';

export const toUSCompactDateFormat = (date) =>
  moment(date).format(US_COMPACT_DATE_FORMAT);

export const toUSCompactDateFormatWithTimeAndTZ = (date) =>
  moment(date).format(US_COMPACT_DATE_FORMAT_WITH_TIME_AND_TZ);

export const toISODateFormat = (date) => moment(date).format(ISO_DATE_FORMAT);
export const fromISODateFormat = (dateString) =>
  moment(dateString, ISO_DATE_FORMAT, true);

export const toUSFormat = (date) => moment(date).format(US_DATE_FORMAT);
export const fromUSFormat = (dateString) =>
  moment(dateString, US_DATE_FORMAT, true);

export const toHumanDateTimeWithTZ = (date) =>
  moment(date).format(US_HUMAN_DATE_TIME_WITH_TZ).trim();

export const toHumanTimeFormat = (date) =>
  moment(date).format(HUMAN_TIME_FORMAT);

export const ifValidOrNow = (date) => {
  const momentDate = moment(date);
  return momentDate.isValid() ? momentDate : now();
};

// TODO: remove toYearMonthDay, and rename its usages to toISODateFormat
export const toYearMonthDay = toISODateFormat;

export const formatToYearMonthDay = (date) => {
  if (!date) return;

  return moment(date).format(ISO_DATE_FORMAT);
};

export const months = [
  { name: 'January', maxDays: 31 },
  { name: 'February', maxDays: 28 },
  { name: 'March', maxDays: 31 },
  { name: 'April', maxDays: 30 },
  { name: 'May', maxDays: 31 },
  { name: 'June', maxDays: 30 },
  { name: 'July', maxDays: 31 },
  { name: 'August', maxDays: 31 },
  { name: 'September', maxDays: 30 },
  { name: 'October', maxDays: 31 },
  { name: 'November', maxDays: 30 },
  { name: 'December', maxDays: 31 },
];

export function isPastDay(date) {
  const datePlusOneDay = moment(date).add(1, 'day');
  return date && datePlusOneDay < now();
}

export function humanizeTimezone(tz) {
  if (!tz) return '';

  const offset = momentTimezone().tz(tz).format('z');
  const parsedTimezoneName = tz.split('/').join(' / ').replace(/_/g, ' ');

  return `${offset} - ${parsedTimezoneName}`;
}

export function humanizeHours(value) {
  if (value < 24) {
    return humanizeWithPlural(value, 'hour');
  }

  const days = Math.floor(value / 24);
  const hours = value % 24;

  const humanizedDays = humanizeWithPlural(days, 'day');
  const humanizedHours = humanizeWithPlural(hours, 'hour');

  return hours === 0 ? humanizedDays : `${humanizedDays} and ${humanizedHours}`;
}

function humanizeWithPlural(value, name) {
  return `${value} ${name}${value > 1 ? 's' : ''}`;
}

export function generateGreetings() {
  const currentHour = +moment().format('HH');

  if (currentHour >= 3 && currentHour < 12) {
    return 'Good morning';
  }

  if (currentHour >= 12 && currentHour < 17) {
    return 'Good afternoon';
  }

  if (currentHour >= 17 && currentHour < 23) {
    return 'Good evening';
  }

  if (currentHour >= 23 || currentHour < 3) {
    return 'Good night';
  }

  return 'Hello';
}
